import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthenticationState {
  test: string;
  email: string;
  callbackUrl: string;
  invitedToken: string | null;
  mobileActiveSection: string;
  setMobileActiveSection: (mobileActiveSection: string) => void;
  setTest: (test: string) => void;
  setEmail: (email: string) => void;
  setCallBackUrl: (callbackUrl: string) => void;
  setInvitedToken: (callbackUrl: string | null) => void;
}

interface AuthenticationModal {
  showAuthModal: boolean;
  setShowAuthModal: (showAuthModal: boolean) => void;
}

export const useAuthenticationStore = create<AuthenticationState>()(
  persist(
    (set) => ({
      test: "",
      email: "",
      callbackUrl: "",
      invitedToken: "",
      mobileActiveSection: "Holtels",
      setMobileActiveSection: (mobileActiveSection) =>
        set({ mobileActiveSection }),
      setTest: (test) => set({ test }),
      setEmail: (email) => set({ email }),
      setCallBackUrl: (callbackUrl) => set({ callbackUrl }),
      setInvitedToken: (invitedToken) => set({ invitedToken }),
    }),
    { name: "auth" },
  ),
);

export const useAuthenticationModalStore = create<AuthenticationModal>()(
  (set) => ({
    showAuthModal: false,
    setShowAuthModal: (showAuthModal) => set({ showAuthModal }),
  }),
);
